(function (root) {
  'use strict';

  var METER_LOOKUP = {
    anker: {
      p1: { handle: 'anker-solix-p1-meter' },
      ct: { handle: 'anker-solix-smart-meter-gen-2-single-phase', needsPhase: true }
    },
    zendure: {
      p1: { handle: 'zendure-p1-meter' },
      ct: { handle: 'zendure-ct-meter' }
    },
    ecoflow: {
      p1: { handle: 'ecoflow-p1-meter' },
      ct: { handle: null }
    },
    marstek: {
      p1: { handle: null },
      ct: { handle: null }
    },
    lunergy: {
      p1: { handle: 'lunergy-p1-meter' },
      ct: { handle: null }
    }
  };

  var THREE_PHASE_VARIANT_ID = 54149648220493;
  var ESTIMATED_ANNUAL_KWH_FALLBACK = 2900;
  var FREE_P1_BRANDS = ['anker', 'ecoflow', 'lunergy'];

  function clamp01(n) {
    return Math.max(0, Math.min(1, n));
  }

  function backupFilterPasses(product, backupLevel) {
    var types = product.backup_types_supported || [];
    if (backupLevel === 'full') return types.indexOf('full_home') !== -1;
    if (backupLevel === 'partial') return types.indexOf('partial') !== -1 || types.indexOf('full_home') !== -1;
    return true;
  }

  function ctFilterPasses(product, dsmrVersion) {
    if (dsmrVersion !== '2.2') return true;
    var meters = product.meter_types_supported || [];
    return meters.indexOf('ct') !== -1;
  }

  function applyHardFilters(products, answers, opts) {
    opts = opts || {};
    return products.filter(function (p) {
      if (!p.data_verified) return false;
      if (!opts.skipBackupFilter && !backupFilterPasses(p, answers.backup_level)) return false;
      if (!ctFilterPasses(p, answers.dsmr_version)) return false;
      return true;
    });
  }

  function scoreCandidate(product, answers) {
    var estimatedNeed = (answers.energy && answers.energy.annual_usage_kwh != null)
      ? answers.energy.annual_usage_kwh
      : ESTIMATED_ANNUAL_KWH_FALLBACK;

    var wantsExpansion = answers.future_expansion && answers.future_expansion !== 'none';
    var relevantCapacity = (wantsExpansion && product.max_expandable_capacity_kwh)
      ? product.max_expandable_capacity_kwh
      : product.base_capacity_kwh;

    // Capacity fit: full score once capacity covers ~2 days of average draw —
    // no single home battery is meant to cover a full year of consumption,
    // so scoring against the whole annual figure would flatten every
    // candidate's score near zero.
    var dailyNeedX2 = (estimatedNeed / 365) * 2;
    var capacityFit = dailyNeedX2 > 0 ? clamp01(relevantCapacity / dailyNeedX2) : 1;

    var outputTarget = answers.high_inrush_appliances ? 4000 : 2000;
    var outputAdequacy = clamp01(product.continuous_output_w / outputTarget);

    var expandability = 0;
    if (wantsExpansion && product.base_capacity_kwh > 0) {
      var weight = answers.future_expansion === 'both' ? 1 : 0.6;
      var headroom = ((product.max_expandable_capacity_kwh || product.base_capacity_kwh) - product.base_capacity_kwh) / product.base_capacity_kwh;
      expandability = clamp01(headroom) * weight;
    }

    return capacityFit + outputAdequacy + expandability;
  }

  function rankCandidates(products, answers) {
    var filtered = applyHardFilters(products, answers);
    var relaxed = false;
    if (filtered.length === 0) {
      filtered = applyHardFilters(products, answers, { skipBackupFilter: true });
      relaxed = filtered.length > 0;
    }

    var scored = filtered
      .map(function (p) { return { product: p, score: scoreCandidate(p, answers) }; })
      .sort(function (a, b) { return b.score - a.score; });

    return {
      primary: scored.length > 0 ? scored[0].product : null,
      alternates: scored.slice(1, 3).map(function (s) { return s.product; }),
      relaxedFilter: relaxed
    };
  }

  function getMeterRecommendation(brand, dsmrVersion) {
    var brandLookup = METER_LOOKUP[brand];
    if (!brandLookup) return null;

    var hardCtRequired = dsmrVersion === '2.2';
    var softCtRecommended = dsmrVersion === '4.0' || dsmrVersion === 'unknown';
    var meterType = (hardCtRequired || softCtRecommended) ? 'ct' : 'p1';
    var entry = brandLookup[meterType];

    var qualifiesForFreeP1 = FREE_P1_BRANDS.indexOf(brand) !== -1 && !!brandLookup.p1.handle;

    return {
      meterType: meterType,
      handle: entry.handle,
      hasProduct: !!entry.handle,
      required: meterType === 'p1' || hardCtRequired,
      needsPhaseSelection: !!entry.needsPhase,
      landisGyrWarning: meterType === 'p1',
      free: meterType === 'p1' && qualifiesForFreeP1,
      // Set only when the *main* recommendation is CT — these brands' P1 meter
      // ships free with the battery regardless of which meter is actually
      // needed, so it's still shown (as a free bonus line) even when CT is
      // the one being pushed for cart-add.
      freeP1Handle: (meterType === 'ct' && qualifiesForFreeP1) ? brandLookup.p1.handle : null
    };
  }

  var api = {
    applyHardFilters: applyHardFilters,
    scoreCandidate: scoreCandidate,
    rankCandidates: rankCandidates,
    getMeterRecommendation: getMeterRecommendation,
    THREE_PHASE_VARIANT_ID: THREE_PHASE_VARIANT_ID
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  } else {
    root.SBCalcRecommend = api;
  }
})(typeof window !== 'undefined' ? window : this);
